// ANCHOR Base
import { Block } from 'baseui/block';
import { Input } from 'baseui/input';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemAnswer,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonViewAnswerFormQuestionStatusIcon } from '../../LyonViewAnswerFormQuestionStatusIcon';

// ANCHOR Constants
import { TITLE, PLACEHOLDER } from './constants';

// ANCHOR Styles
import { BLOCK, INPUT } from './styles';

export const LyonViewAnswerFormShortAnswer = constant(() => {
  const userAnswers = useFormSubmissionQuestionItemAnswer();

  return (
    <Block overrides={BLOCK}>
      <Input
        value={userAnswers[0]}
        placeholder={PLACEHOLDER}
        name={TITLE}
        overrides={INPUT}
        size="default"
      />
      <LyonViewAnswerFormQuestionStatusIcon />
    </Block>
  );
});
